export default __webpack_public_path__ + "static/media/ola.6a79c48f.png";